import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import { createStyles } from "@material-ui/core";

// 全バリアント共通のサイズ・余白。
//
// width は「最小幅」として扱い、ラベルが収まらない場合はボタン側が広がるようにしている。
// 固定幅にすると、MUI Button の左右パディング(16px×2)を含めた必要幅を超えたときに
// ラベルが折り返してしまうため(例: width=100 に「キャンセル」= 16px×5 + 32px = 112px)。
const sizing = (theme) => (props) => ({
  fontSize: props.fontSize ?? 16,
  height: props.height ?? 32,
  minWidth: props.width ?? 116,
  width: "auto",
  whiteSpace: "nowrap",
  marginBottom: props.bottom ?? 16,
  marginRight: 8,
  marginLeft: 8,
  [theme.breakpoints.down("sm")]: {
    fontSize: props.fontSize ? props.fontSize * 0.7 : 11, // 小画面ではフォントサイズを小さくする
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: props.fontSize || 16, // 通常はpropsで渡されたフォントサイズを使用
  },
});

// useStyles内でpropsを受け取り、動的にスタイルを適用
const useStyles = makeStyles((theme) => {
  const base = sizing(theme);
  return createStyles({
    primary: (props) => ({
      ...base(props),
      backgroundColor: theme.palette.primary.main,
      color: "#000",
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
    }),
    placed: (props) => ({
      ...base(props),
      backgroundColor: "#1976d2",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#3b96f1",
      },
    }),
    delete: (props) => ({
      ...base(props),
      backgroundColor: theme.palette.error.main,
      color: "#fff",
      "&:hover": {
        backgroundColor: theme.palette.error.light,
      },
    }),
    received: (props) => ({
      ...base(props),
      backgroundColor: "#8559eb",
      color: "#fff",
      "&:hover": {
        backgroundColor: theme.palette.error.light,
      },
    }),
    grey: (props) => ({
      ...base(props),
      backgroundColor: theme.palette.grey["300"],
    }),
    // 各色のクラスがbackgroundColorを指定しているため、MUI既定の無効スタイルより
    // 優先度を上げる必要がある(クラス2つ分の詳細度にする)
    disabled: {
      "&.Mui-disabled": {
        backgroundColor: theme.palette.grey["300"],
        color: theme.palette.grey["600"],
      },
    },
  });
});

const ColorButtons = (props) => {
  const { color, label, onClick, width, height, fontSize, bottom, disabled } =
    props;
  const classes = useStyles({ width, height, fontSize, bottom }); // propsで幅、高さ、フォントサイズを渡す
  const colorClass =
    color === "primary"
      ? classes.primary
      : color === "delete"
      ? classes.delete
      : color === "received"
      ? classes.received
      : color === "placed"
      ? classes.placed
      : classes.grey;
  return (
    <Button
      // disabledは省略可。渡さなければ従来どおり常に押せる
      className={`${colorClass} ${classes.disabled}`}
      variant="contained"
      onClick={onClick}
      disabled={!!disabled}
    >
      {label}
    </Button>
  );
};

export default ColorButtons;
